import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { MotifTabNavigation, MotifTabControl } from '@ey-xd/motif-react';
import { Link } from 'react-router';
import { reduxForm, reset, getFormValues } from 'redux-form';
import { withRouter } from '../../common/withRouter';
import OwnershipHeader from '../../components/bulkPeriodManagement/OwnershipHeader';
import * as periodActions from '../../actions/periodActions';
import * as propertyActions from '../../actions/propertyActions';
import OwnershipTable from '../../components/bulkPeriodManagement/OwnershipTable';
import { store } from '../../store/configureStore';
import UploadOwnershipModal from '../../components/bulkPeriodManagement/UploadOwnershipModal';

/**
 * MasterDataManagementTRSContainer component
 * @extends {React.Component}
 */
class PropertiesDashBoardContainer extends Component {
  /**
   * Creates a new PropertiesDashBoardContainer
   * @constructor
   * @param {Object} props The component properties
   * @param {Object} context The component context
   */
  constructor(props, context) {
    super(props, context);
    this.handleGridChanges = this.handleGridChanges.bind(this);
    this.setGridColumnState = this.setGridColumnState.bind(this);
    this.handleGridColumnStateChange =
      this.handleGridColumnStateChange.bind(this);
    this.handleTabClick = this.handleTabClick.bind(this);
    this.handleUploadOwnershipImportTemplate =
      this.handleUploadOwnershipImportTemplate.bind(this);
    this.handleExportOwnershipImportTemplate =
      this.handleExportOwnershipImportTemplate.bind(this);
    this.handleEditOwnershipPercentage =
      this.handleEditOwnershipPercentage.bind(this);
    this.toggleGridEditMode = this.toggleGridEditMode.bind(this);
    this.state = {
      gridCurrentState: [],
      gridColumnState: [],
      disableAction: false,
      showUploadOwnershipModal: false,
      periodDescription: '',
      hasPropertyData: true,
      isEditModeActive: false,
      gridDataAfterAction: [],
      resetUpdatedRowDataTrigger: 0,
    };
  }

  /**
   * Invoked immediately after mounting occurs
   * @returns {undefined}
   */
  componentDidMount() {
    this.props.periodActions
      .fetchPeriodById(this.props.periodId)
      .then((period) => {
        this.setState({
          periodDescription: period.reportPeriodDescription,
        });

        this.props.propertyActions.fetchOwnershipDataByPeriod(
          this.props.clientId,
          period.reportPeriodDescription,
          this.props.periodId
        );
      });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.periodId !== this.props.periodId) {
      this.props.propertyActions.fetchOwnershipDataByPeriod(
        this.props.clientId,
        this.state.periodDescription,
        this.props.periodId
      );
    }

    if (
      this.props.ownershipData &&
      this.props.ownershipData !== prevProps.ownershipData
    ) {
      const hasPropertyData = this.props.ownershipData?.some(
        (row) => row.propertyName && row.propertyTrackingID
      );
      this.setState({
        ownershipData: this.props.ownershipData,
        disableAction: hasPropertyData, // Set actionValue based on property data presence
        hasPropertyData: hasPropertyData,
      });
    }
  }

  //Set tab related state variables
  setActiveTab(currentIndex) {
    this.setState({ tabBar1: currentIndex });
  }

  //Set current tab index based
  handleTabClick(index) {
    this.setActiveTab(index);
  }
  /**
   * Activates edit mode for Ownership% .
   * This method updates the component's state by setting `isEditModeActive` to `true`,
   * allowing for modifications to the Ownership%.
   */
  handleEditOwnershipPercentage() {
    this.setState({
      isEditModeActive: true,
      resetUpdatedRowDataTrigger: Date.now(),
      gridDataAfterAction: Array.isArray(this.props.ownershipData)
        ? [...this.props.ownershipData]
        : [],
    });
  }

  /**
   * Toggles the edit mode for the grid.
   * This method updates the component's state by switching the `isEditModeActive` value
   * between `true` and `false`, enabling or disabling edit functionality dynamically.
   */
  toggleGridEditMode(action, gridApi) {
    if (action === 'save') {
      const displayedData = [];

      if (gridApi) {
        gridApi.forEachNodeAfterFilterAndSort((node) => {
          displayedData.push(node.data); // Collect displayed row data
        });
      }

      const finalOwnershipPercentageList = displayedData
        .filter((item) => item.propertyID)
        .map((item) => {
          return typeof item === 'object' && item !== null ? { ...item } : {};
        });

      // Save the percentage of ownership data to the database
      this.props.propertyActions
        .updatePercentageOfOwnership(finalOwnershipPercentageList)
        .then(() => {
          const randomNum = parseInt(Math.random() * (99999999 - 1)) + 1;

          this.setState({
            isEditModeActive: false,
            resetUpdatedRowDataTrigger: randomNum,
          });

          // Fetch the updated property ownership data using the correct periodDescription
          this.props.propertyActions.fetchOwnershipDataByPeriod(
            this.props.clientId,
            this.state.periodDescription,
            this.props.periodId
          );
        });
    } else if (action === 'cancel') {
      this.setState({
        isEditModeActive: false,
        gridDataAfterAction: Array.isArray(this.props.ownershipData)
          ? [...this.props.ownershipData]
          : [],
        resetUpdatedRowDataTrigger: Date.now(),
      });
    }
  }

  /**
   * Set AG-Grid column state
   * @returns {undefined}
   */
  setGridColumnState() {
    const columnState = localStorage.getItem('REITSuiteOwnershipColumnState');
    if (columnState) {
      this.setState({ gridColumnState: JSON.parse(columnState) });
    } else {
      this.setState({ gridColumnState: [{ colId: '-1' }] });
    }
  }

  /**
   * Handle Grid column state chagne
   * @returns {undefined}
   */
  handleGridColumnStateChange(columnState) {
    this.setState({ gridColumnState: columnState });
  }

  handleGridChanges(gridRowData) {
    const rowData =
      gridRowData &&
      gridRowData.length &&
      gridRowData.map((x) => {
        return {
          reitTrackingID: x.reitTrackingID,
          reitName: x.reitName,
          propertyName: x.propertyName,
          propertyTrackingID: x.propertyTrackingID,
          percentageOfOwnership: x.percentageOfOwnership,
          propertyTypeDescription: x.propertyTypeDescription,
        };
      });

    this.setState({ gridCurrentState: rowData });
  }

  handleExportOwnershipImportTemplate() {
    this.props.propertyActions.exportOwnershipData(
      this.props.clientId,
      this.state.periodDescription,
      this.props.periodId
    );
  }

  handleUploadOwnershipImportTemplate() {
    this.setState({ showUploadOwnershipModal: true });
  }

  toggleUploadOwnershipModal = () => {
    this.setState({
      showUploadOwnershipModal: !this.state.showUploadOwnershipModal,
    });
    this.props.propertyActions.fetchOwnershipDataByPeriod(
      this.props.clientId,
      this.state.periodDescription,
      this.props.periodId
    );
  };

  render() {
    if (!this.props.ownershipData?.length) {
      return (
        <div>
          <h2>Properties</h2>
          <div>No Property found for this report period.</div>
        </div>
      );
    }

    return (
      <div>
        <h2>Properties</h2>
        <MotifTabNavigation variant="default">
          <Link
            to={`/client/${this.props.clientId}/reit/${this.props.reitId}/period/${this.props.periodId}/properties/ownership`}
            tabIndex="-1"
          >
            <MotifTabControl
              className="motif-active"
              role="tab"
              data-testid="tbOwnership%"
              onClick={() => this.handleTabClick(3)}
            >
              Ownership %
            </MotifTabControl>
          </Link>
          <Link
            to={`/client/${this.props.clientId}/reit/${this.props.reitId}/period/${this.props.periodId}/properties/tenantServicesAmenities`}
            tabIndex="-1"
          >
            <MotifTabControl
              role="tab"
              data-testid="tbTenantServices"
              onClick={() => this.handleTabClick(4)}
            >
              Tenant Services / Amenities
            </MotifTabControl>
          </Link>
        </MotifTabNavigation>
        <OwnershipHeader
          latestReportPeriod={this.state.latestReportPeriod}
          disableAction={this.state.disableAction} // Pass diableAction to the header
          handleExportOwnershipImportTemplate={
            this.handleExportOwnershipImportTemplate
          }
          handleUploadOwnershipImportTemplate={
            this.handleUploadOwnershipImportTemplate
          }
          isReportPeriodSpecific={true}
          handleEditOwnershipPercentage={this.handleEditOwnershipPercentage}
          isEditModeActive={this.state.isEditModeActive}
        />
        {this.state.showUploadOwnershipModal && (
          <UploadOwnershipModal
            show={this.state.showUploadOwnershipModal}
            onClose={this.toggleUploadOwnershipModal}
            reportPeriod={this.state.periodDescription}
            reportPeriodId={this.props.periodId}
          />
        )}
        <OwnershipTable
          ownershipData={this.props.ownershipData || []} // Pass ownershipData correctly
          handleGridChanges={this.handleGridChanges}
          gridColumnState={this.state.gridColumnState}
          gridCurrentState={this.state.gridCurrentState}
          handleGridColumnStateChange={this.handleGridColumnStateChange}
          isEditModeActive={this.state.isEditModeActive}
          toggleGridEditMode={this.toggleGridEditMode}
          gridDataAfterAction={
            Array.isArray(this.state.gridDataAfterAction)
              ? this.state.gridDataAfterAction
              : []
          }
          resetUpdatedRowDataTrigger={this.state.resetUpdatedRowDataTrigger}
        />
      </div>
    );
  }
}

PropertiesDashBoardContainer.propTypes = {
  clientId: PropTypes.number,
  periodActions: PropTypes.object,
  propertyActions: PropTypes.object,
  periods: PropTypes.array,
  ownershipData: PropTypes.array,
  reitId: PropTypes.number.isRequired,
  periodId: PropTypes.number.isRequired,
};

/**
 * Maps items from state to properties of the component
 * @param {Object} state The state
 * @returns {Object} An object containing properties that the component can access
 */
function mapStateToProps(state, ownProps) {
  let cid = Number.parseInt(ownProps.router.params.clientId);
  if (isNaN(cid)) {
    cid = 0;
  }

  return {
    clientId: cid,
    periods: state.periods,
    ownershipData: state.ownershipData,
    disableAction: state.disableAction,
    periodId: Number.parseInt(ownProps.router.params.periodId),
    reitId: Number.parseInt(ownProps.router.params.reitId),
  };
}

/**
 * Binds actions to the dispatcher
 * @param {Object} dispatch The action dispatcher
 * @returns {Object} An object containing properties that the component can access
 */
function mapDispatchToProps(dispatch) {
  return {
    periodActions: bindActionCreators(periodActions, dispatch),
    propertyActions: bindActionCreators(propertyActions, dispatch), // Ensure propertyActions is bound correctly
  };
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(
    reduxForm({
      form: 'ownershipForm',
      enableReinitialize: true,
    })(PropertiesDashBoardContainer)
  )
);
